<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/LvCEZQ/docimages/cover.jpg?1688985129411" alt="This image is the cover for the book Higher Earth Vol. 1, Higher Earth"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Higher Earth Vol. 1, Higher Earth
      </h1>
      <p class="bookDescription body article font2">
        <p>When the final frontier proves to be a desolate wasteland, mankind turns its sights toward exploring -- and conquering -- a different sort of territory: alternate Earths. HIGHER EARTH, written and created by Sam Humphries, takes place in a universe of interconnected Earths, with many falling under the empire of the titular throne world.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sam Humphries
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      BOOM! Studios
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?00212857